<template>
  <div class="changePasswordContainer">
    <div class="grid imgGrid">
      <img
        class="imgContainer"
        src="@/assets/images/mosquita_forgotten_password.png"
      />
      <p class="nunitoBold subheaderText">
        {{ $t('k_change_password_title') }}
      </p>
      <p class="ralewayRegular subheaderText2">
        {{ $t('k_change_password_description') }}
      </p>
    </div>

    <form action="#" @submit.prevent="submit">
      <div class="formContainer mt-5">
        <div class="formElement mb-4" v-if="userLogged && !fromResetLink">
          <label class="ralewayRegular formInputLabel" for="oldPassword">{{
            $t('k_current_password')
          }}</label>
          <input
            class="formInput ralewayRegular"
            type="password"
            name="oldPassword"
            v-model="oldPassword"
            v-bind:placeholder="$t('k_pw_type')"
          />
        </div>
        <div class="formElement mb-4">
          <label class="ralewayRegular formInputLabel" for="newPassword">{{
            $t('k_new_password')
          }}</label>
          <ValidationProvider
            name="password"
            rules="min:6|required|max:20"
            v-slot="{ errors }"
          >
            <input
              class="formInput ralewayRegular"
              type="password"
              name="newPassword"
              v-model="newPassword"
              v-bind:placeholder="$t('k_pw_type')"
            />
            <span class="ralewayRegular errorText">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="formElement mb-4">
          <label
            class="ralewayRegular formInputLabel"
            for="confirmNewPassword"
            >{{ $t('k_confirm_new_password') }}</label
          >
          <ValidationProvider
            name="password"
            rules="min:6|required|max:20"
            v-slot="{ errors }"
          >
            <input
              class="formInput ralewayRegular"
              type="password"
              name="confirmNewPassword"
              v-model="confirmNewPassword"
              v-bind:placeholder="$t('k_pw_type')"
            />
            <span class="ralewayRegular errorText">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
      </div>

      <div class="grid mt-10 stButtonGrid">
        <span class="ralewayRegular errorText" v-if="!passwordMatch">{{
          $t('password_not_equals')
        }}</span>
        <div class="stButton registerButton">
          <div class="stButtonCaption nunitoBold" v-on:click="submit()">
            {{ $t('k_change_password_title') }}
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import { ValidationProvider } from 'vee-validate'
import { mapGetters } from 'vuex'
import { trackEvent } from '../plugins/analyticsTracker'

export default {
  components: {
    ValidationProvider
  },
  computed: {
    ...mapGetters({ userLogged: 'isUserLogged' })
  },
  mounted: function() {
    this.fromResetLink = this.$route.query.oobCode
    console.log(this.fromResetLink)
    console.log(this.fromResetLink)
  },
  data() {
    return {
      fromResetLink: false,
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      confirmMessage: '',
      error: null,
      passwordMatch: true
    }
  },
  methods: {
    submit: async function() {
      try {
        this.passwordMatch = this.confirmNewPassword == this.newPassword
        if (this.passwordMatch) {
          if (this.userLogged) {
            var user = firebase.auth().currentUser
            console.log(user)
            await user.reauthenticateWithCredential(
              firebase.auth.EmailAuthProvider.credential(
                user.email,
                this.oldPassword
              )
            )
            await user.updatePassword(this.confirmNewPassword)
          } else {
            const code = this.$route.query.oobCode
            await firebase.auth().verifyPasswordResetCode(code)
            await firebase
              .auth()
              .confirmPasswordReset(code, this.confirmNewPassword)
          }
          trackEvent(this.$constants.WEB_RESTOREPWD_DONE)
        }
        this.$router.push({
          path: 'reset-password-done',
          query: { changePassword: true }
        })
      } catch (error) {
        console.log(error)
        if (error.code == 'auth/weak-password') {
          this.$confirm({
            message: this.$i18n.t('k_register_short_password'),
            button: {
              yes: this.$i18n.t('k_confirm_title')
            }
          })
        } else {
          await this.$store.dispatch('setError', {
            errorKey: 'k_generic_error_title',
            errorSubKey: 'k_reset_password_fail',
            errorImage: '@/assets/images/mosquita_generic_error.png',
            redirect: '/login'
          })
          this.$router.push('error')
        }
      }
    },
    goBack: function() {
      this.$router.push('/')
    }
  }
}
</script>
<style lang="scss">
.changePasswordContainer {
  .registerButton {
    grid-row: 1;
    grid-column: 2/12;
    padding: 10px 0px;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .buttonCaption {
    grid-row: 1;
    grid-column: 4/13;
    display: flex;
    font-size: 1.1875em;
  }

  .stButtonCaption {
    grid-row: 1;
    grid-column: 1/13;
    font-size: 1.1875em;
  }

  .hrLine {
    width: 100%;
    text-align: center;
    border-bottom: 0.2px solid var(--line2);
    line-height: 0.1em;
    margin: 10px 0 20px;
    grid-row: 1;
    grid-column: 2/12;
  }

  .hrLine span {
    padding: 0 10px;
    background: #fff;
    color: var(--line1);
    font-size: 0.5em;
  }

  .formContainer {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .formElement {
    grid-column: 2/12;
  }

  .formInputLabel {
    display: flex;
    font-size: 1em;
    color: var(--formColor);
  }
  .formInput {
    padding: 10px 15px;
    width: 100%;
    border-radius: 5px;
    border: 1px solid var(--outlineInput);
    font-size: 1em;
    color: var(--formColor);
  }

  .checkboxLabel {
    font-size: 0.688em;
    color: var(--formColor);
    grid-column: 3/8;
  }

  .accept {
    display: flex;
    grid-column: 2/3;
    align-self: center;
  }
  @media screen and (min-width: 620px) {
    .stButtonGrid {
      max-width: 600px;
      margin: auto;
    }

    .formContainer {
      max-width: 600px;
      margin: auto;
    }
  }
  /* large tablet and laptop styles */
  @media screen and (min-width: 960px) {
  }
  /* desktop styles */
  @media screen and (min-width: 1200px) {
  }
}
</style>
